import { useQuery } from "@tanstack/react-query"
import { fetchChainStatus } from "api/ApiCalls"
import type { ChainStatusResponse } from "types/ApiTypes"

export function useChainStatus() {
  return useQuery<ChainStatusResponse>({
    queryKey: ["chain-status"],
    queryFn: fetchChainStatus,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  })
}
